import { render, staticRenderFns } from "./ClaimDialog.vue?vue&type=template&id=2375b917&scoped=true"
import script from "./ClaimDialog.vue?vue&type=script&lang=js"
export * from "./ClaimDialog.vue?vue&type=script&lang=js"
import style0 from "./ClaimDialog.vue?vue&type=style&index=0&id=2375b917&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2375b917",
  null
  
)

export default component.exports